import * as types from "./types";

export const setConnectionFlag = flag => {
  return {
    type: types.SET_CONNECTION_FLAG,
    payload: flag,
  };
};

export const storeWiFiDetails = ({
  wifi_name,
  wifi_mac,
  wifi_connected_at,
}) => {
  return {
    type: types.STORE_WIFI_DETAILS,
    payload: { wifi_name, wifi_mac, wifi_connected_at },
  };
};
